module.exports = __webpack_public_path__ + "img/sales_payment_link.bd83d140.svg";